import type { EbmResourceConfigPaths } from './types';

export function resolveEbmResourceConfigPaths(_prefix = ''): EbmResourceConfigPaths {
  return {
    resourceConfiguration: 'resourceConfiguration',
  };
}
